import './css/App.scss';
import Header from './layout/Header';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './layout/ScrollToTop';
import AppRoutes from './routes';
import ModalState from './context/modal/ModalState';
import ErrorState from './context/error/ErrorState';
import { Web3ReactProvider } from '@web3-react/core';
import ConnectionState from './context/connection/ConnectionState';
import { Web3Provider } from '@ethersproject/providers';
import { SWRConfig } from 'swr';
import Footer from './layout/Footer';
import ModalsContainer from './modals/ModalsContainer';
import BottomNav from './layout/BottomNav';
import DemoDisclaimerLauncher from './components/DemoDisclaimerLauncher';
import ReferralState from './context/referral/ReferralState';
import SocketProvider from './context/socket/SocketProvider';
import NetworkIndicator from './components/NetworkIndicator';
import ToastState from './context/toast/ToastState';
import TransactionState from './context/transaction/TransactionState';

const App = () => {
    const getLibrary = (provider: any): Web3Provider => {
        const library = new Web3Provider(provider);
        library.pollingInterval = 12000;

        return library;
    };

    if (process.env.NODE_ENV === 'production') {
        console.log = () => {};
        console.info = () => {};
        console.warn = () => {};
        console.error = () => {};
        console.debug = () => {};
        console.table = () => {};
    }

    return (
        <Router>
            <SWRConfig
                value={{
                    errorRetryCount: 5,
                    dedupingInterval: 60000,
                }}
            >
                {/* <SocketProvider> */}
                <ModalState>
                    <ToastState>
                        <ErrorState>
                            <Web3ReactProvider getLibrary={getLibrary}>
                                <ConnectionState>
                                    <ReferralState>
                                        <TransactionState>
                                            <NetworkIndicator />
                                            <ScrollToTop />
                                            <Header />
                                            <main>
                                                <AppRoutes />
                                            </main>
                                            <Footer />
                                            <BottomNav />
                                        </TransactionState>
                                    </ReferralState>
                                    <ModalsContainer />
                                    <DemoDisclaimerLauncher />
                                </ConnectionState>
                            </Web3ReactProvider>
                        </ErrorState>
                    </ToastState>
                </ModalState>
                {/* </SocketProvider> */}
            </SWRConfig>
        </Router>
    );
};

export default App;
